import { PaymentMethod, Payments, PaymentType } from '@prisma/client';

export const PAYMENT_GROUPS_PAGE_SIZE = 10;
export const SORTABLE_KEYS = ['amount', 'createdAt'] as const satisfies Array<
  keyof Payments
>;
export const MINIMUM_PAYMENT_CENTS = 50;
export const MINIMUM_FEE_CENTS = 200;

export const ALLOWED_VOID_PAYMENT_TYPES: PaymentType[] = [
  PaymentType.FULL,
  PaymentType.DEPOSIT,
  PaymentType.RESCHEDULE,
  PaymentType.ORDER,
];

export const ALLOWED_VOID_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.CASH,
  PaymentMethod.GIFT_CARD,
];

export const CREDIT_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.CREDIT,
  PaymentMethod.TERMINAL,
];
